import { call, put, takeLatest } from "redux-saga/effects";
import { delay } from "redux-saga";
import { history } from "../store";
import actions from "../actions/actionTypes";
import { apiRequestFailureAction, apiRequestSuccessAction } from "actions/requestActions";
import { showLoader, hideLoader } from "actions/soleraLoaderActions";

import { fetchChangePassword } from "./Api";

export function* changePasswordRequest(data) {
  yield put(showLoader());
  var body = data.payload;
  let messages = { messages: [] };
  if(body.uid === "" || body.pwd === "" || body.newpwd === "" || body.confirmpwd === "" ){
    messages.messages.push({
      key: null,
      messageText: "All fields are required for changing the password, please verify and try again.",
      type: "warning"
    });
    yield put(apiRequestFailureAction(messages));
    yield put(hideLoader());
    return;
  }
  var response = yield call(fetchSaga, fetchChangePassword, {body});
  if (response.status === false){
    messages.messages.push({
      key: null,
      messageText: `${response.response}`,
      type: "warning"
    });
    yield put(apiRequestFailureAction(messages));
  }else{
    messages.messages.push({
      key: null,
      messageText: `${response.response}, you will be logged out.`,
      type: "info"
    });
    yield put(apiRequestSuccessAction(messages));
    yield call(delay, 2500);
    history.push("/logout");
  }
  yield put(hideLoader());
}

export default function* fetchSaga(fn, args = {}, raw = false) {
  var result = {};
  const authArgs = { ...args };
  const response = yield call(fn, authArgs);
  switch(response.status){
    case 200:
      result.status = true;
      result.response = yield call(response.text.bind(response));
      break;
    case 400:
      result.status = false;
      var error = yield call(response.json.bind(response));
      result.response = error.Error;
      break;
    case 500:
      result.status = false;
      result.response = yield call(response.text.bind(response));
      break;
    default:
      result.status = false;
      result.response = "Something went wrong please try again.";
      break;
  }
  return result;
}

export const changePasswordSagas = [
  takeLatest(actions.CHANGE_PASSWORD, changePasswordRequest)
];